import { render, staticRenderFns } from "./SynchronizedParallax.vue?vue&type=template&id=10da0840&"
import script from "./SynchronizedParallax.vue?vue&type=script&lang=js&"
export * from "./SynchronizedParallax.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizedParallax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports